import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./add-building.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./add-building.component.scss?ngResource";
import { Component, Input } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { AppControllerService } from "../../../../../app-controller.service";
import { AlertType } from "../../../../../shared/models/alert";
import { CreateApplicationLocationBpamsConstants } from "../create-application-location-bpams.constants";
import { AppConfig } from "../../../../../app.config";
let AddBuildingComponent = class AddBuildingComponent {
    activeModal;
    appController;
    modalTitle;
    type;
    branding = {
        themeMainColor: SharedConstants.DEFAULT_COLOR,
        themeMainDarkerColor: SharedConstants.DEFAULT_DARKER_COLOR,
        themeMainBackgroundColor: SharedConstants.DEFAULT_COLOR,
        themeMainBorderColor: SharedConstants.DEFAULT_COLOR,
        themeHeaderBorderColor: SharedConstants.DEFAULT_HEADER_BORDER_COLOR,
        themeActiveColor: SharedConstants.DEFAULT_ACTIVE_COLOR,
        themeActiveAlternateColor: SharedConstants.DEFAULT_ACTIVE_ALTERNATE_COLOR,
        themePrimaryButtonColor: SharedConstants.DEFAULT_PRIMARY_BUTTON_COLOR
    };
    addForm;
    cancelLabel = SharedConstants.CANCEL_LABEL;
    createLabel = SharedConstants.CREATE_LABEL;
    validationMessages = CreateApplicationLocationBpamsConstants.VALIDATION_MESSAGES;
    floorLabel = CreateApplicationLocationBpamsConstants.FLOOR_LABEL;
    existingSizeLabel = CreateApplicationLocationBpamsConstants.EXISTING_SIZE_LABEL;
    addedSizeLabel = CreateApplicationLocationBpamsConstants.ADDED_SIZE_LABEL;
    buildingNameNumberLabel = CreateApplicationLocationBpamsConstants.BUILDING_NAME_NUMBER_LABEL;
    floorControlName = CreateApplicationLocationBpamsConstants.FLOOR_CONTROL_NAME;
    existingSizeControlName = CreateApplicationLocationBpamsConstants.EXISTING_SIZE_CONTROL_NAME;
    addedSizeControlName = CreateApplicationLocationBpamsConstants.ADDED_SIZE_CONTROL_NAME;
    buildingNameNumberControlName = CreateApplicationLocationBpamsConstants.BUILDING_NAME_NUMBER_CONTROL_NAME;
    constructor(activeModal, appController) {
        this.activeModal = activeModal;
        this.appController = appController;
        if (AppConfig.settings.projectSettings && AppConfig.settings.projectSettings.styling) {
            this.branding = AppConfig.settings.projectSettings.styling;
        }
    }
    ngOnInit() {
        this.addForm = new FormGroup({
            floor: new FormControl(0, [Validators.required]),
            existingSize: new FormControl(null, [Validators.required]),
            addedSize: new FormControl(null, [Validators.required]),
            buildingNameNumber: new FormControl(null)
        });
    }
    onBtnSaveClicked($event) {
        if (this.addForm.valid) {
            const name = {
                floor: this.addForm.get(this.floorControlName).value,
                existingSize: this.addForm.get(this.existingSizeControlName).value,
                addedSize: this.addForm.get(this.addedSizeControlName).value,
                buildingNameNumber: this.addForm.get(this.buildingNameNumberControlName).value,
                type: this.type
            };
            this.activeModal.close(name);
        }
        else {
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
        }
    }
    onBtnCancelClicked($event) {
        this.activeModal.close(null);
    }
    static ctorParameters = () => [
        { type: NgbActiveModal },
        { type: AppControllerService }
    ];
    static propDecorators = {
        modalTitle: [{ type: Input }],
        type: [{ type: Input }]
    };
};
AddBuildingComponent = __decorate([
    Component({
        selector: "app-add-building",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], AddBuildingComponent);
export { AddBuildingComponent };
